import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './DatePicker.css';
import React, { useState, useEffect } from 'react';
import DatePicker from "react-datepicker";
import { addYears } from "date-fns";
import { ar, ru, cs, nl, fi, de, ja, nb, pt, sv, zhCN, da, fr, it, ko, pl, ro, es, uk, tr, enUS } from 'date-fns/locale';
import { ReactComponent as IconArrowLeft } from '../../../resources/icons/IconArrowLeft.svg';
import { ReactComponent as IconArrowRight } from '../../../resources/icons/IconArrowRight.svg';
import { ReactComponent as IconClose } from '../../../resources/icons/close.svg';
import { ReactComponent as IconPlane } from '../../../resources/icons/iconPlane.svg';
import { emptyDateShowObj } from '../index';
var langHash = {
  ar: ar,
  ru: ru,
  cs: cs,
  nl: nl,
  fi: fi,
  de: de,
  ja: ja,
  no: nb,
  pt: pt,
  sv: sv,
  zh: zhCN,
  da: da,
  fr: fr,
  it: it,
  ko: ko,
  pl: pl,
  ro: ro,
  es: es,
  uk: uk,
  tr: tr,
  en: enUS
};
var DatePickerDropDown = function DatePickerDropDown(_ref) {
  var lang = _ref.lang,
    rtl = _ref.rtl,
    dateOpened = _ref.dateOpened,
    closeDateDropdown = _ref.closeDateDropdown,
    depDate = _ref.depDate,
    setDepDate = _ref.setDepDate,
    retDate = _ref.retDate,
    setRetDate = _ref.setRetDate,
    resetFlag = _ref.resetFlag,
    setResetFlag = _ref.setResetFlag,
    returnTicket = _ref.returnTicket,
    setReturnTicket = _ref.setReturnTicket,
    textClear = _ref.textClear,
    oneWayText = _ref.oneWayText,
    datesAvailable = _ref.datesAvailable,
    isMobile = _ref.isMobile,
    enableAmountOpenFlag = _ref.enableAmountOpenFlag,
    mobileStateSelectDepartureDateText = _ref.mobileStateSelectDepartureDateText,
    mobileStateSelectReturnDateText = _ref.mobileStateSelectReturnDateText,
    mobilePlaceholderDepartureDateText = _ref.mobilePlaceholderDepartureDateText,
    mobilePlaceholderReturnDateText = _ref.mobilePlaceholderReturnDateText,
    mobileStateDepartureDateSelectedText = _ref.mobileStateDepartureDateSelectedText,
    mobileStateDepartureReturnDateSelectedText = _ref.mobileStateDepartureReturnDateSelectedText;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    startDate = _useState2[0],
    setStartDate = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    endDate = _useState4[0],
    setEndDate = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    singleDate = _useState6[0],
    setSingleDate = _useState6[1];
  var _useState7 = useState(new Date()),
    _useState8 = _slicedToArray(_useState7, 2),
    minDate = _useState8[0],
    setMinDate = _useState8[1];
  var _useState9 = useState(0),
    _useState10 = _slicedToArray(_useState9, 2),
    availableDatesIndex = _useState10[0],
    setAvailableDatesIndex = _useState10[1];
  var renderTooltipText = function renderTooltipText() {
    return !returnTicket || !startDate || startDate && endDate ? mobilePlaceholderDepartureDateText : mobilePlaceholderReturnDateText;
  };
  var renderDayContents = function renderDayContents(day, date) {
    return /*#__PURE__*/React.createElement("span", {
      className: "react-datepicker__day-text"
    }, /*#__PURE__*/React.createElement("span", {
      className: "react-datepicker__tooltip"
    }, renderTooltipText()), date.getDate());
  };
  var setDayClassName = function setDayClassName(date) {
    if (datesAvailable[availableDatesIndex].length) {
      return datesAvailable[availableDatesIndex].includes(date.toLocaleString('sv').replace(' ', 'T')) ? '' : 'react-datepicker__day--unscheduled';
    }
    return '';
  };
  var renderCustomHeader = function renderCustomHeader(props) {
    var monthDate = props.monthDate,
      decreaseMonth = props.decreaseMonth,
      increaseMonth = props.increaseMonth,
      customHeaderCount = props.customHeaderCount,
      nextMonthButtonDisabled = props.nextMonthButtonDisabled,
      prevMonthButtonDisabled = props.prevMonthButtonDisabled;
    return /*#__PURE__*/React.createElement("div", {
      className: "react-datepicker__header-month"
    }, /*#__PURE__*/React.createElement("span", {
      className: "react-datepicker__current-month"
    }, monthDate.toLocaleString(langHash[lang] ? langHash[lang].code : 'en-US', {
      month: "long",
      year: "numeric"
    })), /*#__PURE__*/React.createElement("button", {
      "aria-label": "Previous Month",
      className: "\n          react-datepicker__navigation react-datepicker__navigation--previous\n          ".concat(isMobile ? 'd-none' : '', "\n          ").concat(customHeaderCount !== 0 || prevMonthButtonDisabled ? 'd-none' : '', "\n        "),
      onClick: decreaseMonth
    }, /*#__PURE__*/React.createElement(IconArrowLeft, {
      className: "icon"
    })), /*#__PURE__*/React.createElement("button", {
      "aria-label": "Next Month",
      className: "\n          react-datepicker__navigation react-datepicker__navigation--next\n          ".concat(isMobile ? 'd-none' : '', "\n          ").concat(customHeaderCount !== 1 || nextMonthButtonDisabled ? 'd-none' : '', "\n        "),
      onClick: increaseMonth
    }, /*#__PURE__*/React.createElement(IconArrowRight, {
      className: "icon"
    })));
  };
  var generateDateObj = function generateDateObj(date) {
    return date ? {
      day: date.toLocaleString(undefined, {
        day: "numeric"
      }),
      dayNumber: date.toLocaleString(undefined, {
        day: "2-digit"
      }),
      month: date.toLocaleString(langHash[lang] ? langHash[lang].code : 'en-US', {
        month: "long"
      }),
      monthNumber: date.toLocaleString('en-US', {
        month: "2-digit"
      }),
      year: date.toLocaleString(undefined, {
        year: "numeric"
      })
    } : emptyDateShowObj;
  };
  var renderDatePickerTitle = function renderDatePickerTitle() {
    if (returnTicket) {
      if (startDate && endDate) return mobileStateDepartureReturnDateSelectedText;
      if (startDate) return mobileStateSelectReturnDateText;
    }
    if (!returnTicket) {
      if (singleDate) return mobileStateDepartureDateSelectedText;
    }
    return mobileStateSelectDepartureDateText;
  };
  useEffect(function () {
    if (!singleDate && !startDate && !endDate || startDate && endDate || singleDate) {
      setAvailableDatesIndex(0);
      return;
    }
    if (startDate && !endDate) {
      setAvailableDatesIndex(1);
      return;
    }
    setAvailableDatesIndex(0);
  }, [singleDate, startDate, endDate, datesAvailable]);
  useEffect(function () {
    if (returnTicket) {
      if (singleDate) {
        setSingleDate(null);
        setStartDate(singleDate);
        setEndDate(singleDate);
        setMinDate(singleDate);
        return;
      }
      if (startDate) {
        setDepDate(generateDateObj(startDate));
        setRetDate(generateDateObj(endDate));
        setMinDate(endDate ? new Date() : startDate);
        return;
      }
    }
    if (startDate) {
      setSingleDate(startDate);
      setStartDate(null);
      setEndDate(null);
      return;
    }
    if (singleDate) {
      setDepDate(generateDateObj(singleDate));
      setRetDate(generateDateObj(singleDate));
      return;
    }
    setDepDate(generateDateObj(null));
    setRetDate(generateDateObj(null));
    setMinDate(new Date());
  }, [returnTicket, startDate, endDate, singleDate]);
  useEffect(function () {
    if (resetFlag) {
      setResetFlag(false);
      setStartDate(null);
      setEndDate(null);
      setSingleDate(null);
    }
  }, [resetFlag]);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    opened: dateOpened
  }, /*#__PURE__*/React.createElement("button", {
    className: "dropdown-close d-none d-md-block",
    onClick: function onClick() {
      closeDateDropdown();
    }
  }, /*#__PURE__*/React.createElement(IconClose, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-md-none dropdown-header"
  }, /*#__PURE__*/React.createElement("button", {
    className: "dropdown-header__back",
    onClick: function onClick() {
      closeDateDropdown();
    }
  }, rtl ? /*#__PURE__*/React.createElement(IconArrowRight, {
    className: "icon"
  }) : /*#__PURE__*/React.createElement(IconArrowLeft, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("h2", {
    className: "dropdown-header__text"
  }, renderDatePickerTitle()), (startDate || singleDate) && /*#__PURE__*/React.createElement("button", {
    className: "dropdown-header__clear",
    onClick: function onClick() {
      setResetFlag(true);
    }
  }, textClear)), /*#__PURE__*/React.createElement("div", {
    className: "d-md-none dropdown-state-area"
  }, /*#__PURE__*/React.createElement("div", {
    className: "\n          dropdown-state-area__cell\n          ".concat(returnTicket && !startDate && !endDate ? 'dropdown-state-area__cell--active' : '', "\n          ").concat(!returnTicket && !singleDate ? 'dropdown-state-area__cell--active' : '', "\n        ")
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "dropdown-state-area__label ".concat(depDate.day ? 'dropdown-state-area__label--selected' : '')
  }, mobilePlaceholderDepartureDateText), depDate.day && /*#__PURE__*/React.createElement("div", {
    className: "d-flex dropdown-state-area__date"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dropdown-state-area__date-day"
  }, depDate.day), /*#__PURE__*/React.createElement("div", {
    className: "dropdown-state-area__date-month"
  }, depDate.month, /*#__PURE__*/React.createElement("br", null), depDate.year)))), returnTicket && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "dropdown-state-area__plane-icon"
  }, /*#__PURE__*/React.createElement(IconPlane, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("div", {
    className: "\n              dropdown-state-area__cell\n              ".concat(returnTicket && startDate && !endDate ? 'dropdown-state-area__cell--active' : '', "\n            ")
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "dropdown-state-area__label ".concat(retDate.day ? 'dropdown-state-area__label--selected' : '')
  }, mobilePlaceholderReturnDateText), retDate.day && /*#__PURE__*/React.createElement("div", {
    className: "d-flex dropdown-state-area__date"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dropdown-state-area__date-day"
  }, retDate.day), /*#__PURE__*/React.createElement("div", {
    className: "dropdown-state-area__date-month"
  }, retDate.month, /*#__PURE__*/React.createElement("br", null), retDate.year)))))), /*#__PURE__*/React.createElement("div", {
    className: "datepicker-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "datepicker-body__head-wrapper d-none d-md-flex"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "datepicker-body__head"
  }, renderDatePickerTitle()), /*#__PURE__*/React.createElement("label", {
    className: "datepicker-body__checkbox-label"
  }, /*#__PURE__*/React.createElement("input", {
    className: "datepicker-body__checkbox",
    type: "checkbox",
    checked: !returnTicket,
    onChange: function onChange() {
      setReturnTicket(!returnTicket);
    }
  }), oneWayText)), /*#__PURE__*/React.createElement(DatePicker, {
    inline: true,
    monthsShown: isMobile ? 13 : 2,
    locale: langHash[lang],
    useWeekdaysShort: true,
    renderCustomHeader: renderCustomHeader,
    startDate: startDate,
    endDate: endDate,
    selected: singleDate,
    selectsRange: returnTicket,
    minDate: returnTicket ? minDate : new Date(),
    maxDate: addYears(new Date(), 1),
    renderDayContents: renderDayContents,
    dayClassName: setDayClassName,
    onChange: function onChange(date) {
      if (Array.isArray(date)) {
        setStartDate(date[0]);
        setEndDate(date[1]);
        if (date[1]) {
          closeDateDropdown();
          enableAmountOpenFlag();
        }
      } else {
        setSingleDate(date);
        closeDateDropdown();
        enableAmountOpenFlag();
      }
    }
  })));
};
var commonStyles = "c4px577";
var ltrStyles = "l1dmtmnl";
var rtlStyles = "r16eem4s";
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    opened = _ref2.opened;
  return /*#__PURE__*/React.createElement("div", {
    className: "\n  datepicker-dropdown\n  ".concat(commonStyles, "\n  ").concat(rtl ? rtlStyles : ltrStyles, "\n  ").concat(opened ? 'datepicker-dropdown--opened' : '', "\n")
  }, children);
};
export default DatePickerDropDown;